import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

export default function Pagination({
    page = 1,
    totalPages = 1,
    pageSize = 10,
    total = 0,
    onPageChange,
    onPageSizeChange,
    showSizeChanger = true,
    pageSizeOptions = [10, 20, 50, 100],
    className = ''
}) {
    const getPageNumbers = () => {
        const pages = [];
        const delta = 2;

        for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
            pages.push(i);
        }

        if (page - delta > 2) {
            pages.unshift('...');
        }
        if (page + delta < totalPages - 1) {
            pages.push('...');
        }

        pages.unshift(1);
        if (totalPages > 1) {
            pages.push(totalPages);
        }

        return pages;
    };

    const startItem = (page - 1) * pageSize + 1;
    const endItem = Math.min(page * pageSize, total);

    return (
        <div className={`pagination ${className}`}>
            <div className="pagination-info">
                Showing <strong>{startItem}</strong> to <strong>{endItem}</strong> of <strong>{total}</strong> results
            </div>
            <div className="pagination-controls">
                {showSizeChanger && (
                    <select
                        className="pagination-size"
                        value={pageSize}
                        onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
                    >
                        {pageSizeOptions.map((size) => (
                            <option key={size} value={size}>{size} / page</option>
                        ))}
                    </select>
                )}
                <div className="pagination-pages">
                    <button
                        className="pagination-btn"
                        onClick={() => onPageChange?.(page - 1)}
                        disabled={page <= 1}
                    >
                        <ChevronLeft size={18} />
                    </button>
                    {getPageNumbers().map((p, idx) => (
                        <button
                            key={idx}
                            className={`pagination-btn ${p === page ? 'active' : ''} ${p === '...' ? 'dots' : ''}`}
                            onClick={() => typeof p === 'number' && onPageChange?.(p)}
                            disabled={p === '...'}
                        >
                            {p}
                        </button>
                    ))}
                    <button
                        className="pagination-btn"
                        onClick={() => onPageChange?.(page + 1)}
                        disabled={page >= totalPages}
                    >
                        <ChevronRight size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
}

Pagination.propTypes = {
    page: PropTypes.number,
    totalPages: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
    onPageChange: PropTypes.func,
    onPageSizeChange: PropTypes.func,
    showSizeChanger: PropTypes.bool,
    pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
    className: PropTypes.string
};
